import { useState, useEffect } from 'react';
import { Pane, Button } from 'evergreen-ui';

function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}
function firstOfWeek(d) {
  const fd = new Date(d);
  const day = fd.getDay();
  // Se day === 0 (domenica), lo facciamo diventare 7 per poter sottrarre 6 e tornare al lunedì.
  // Altrimenti sottraiamo (day - 1).
  const diff = fd.getDate() - day + (day === 0 ? -6 : 1);
  fd.setDate(diff);
  fd.setHours(0,0,0,0);
  return fd;
}

const Calendar = ({ selected, setSelected, appointments = [] }) => {
  const [viewMonth, setViewMonth] = useState(startOfMonth(new Date()));
  const [rows, setRows] = useState([]);
  const [highlightedWithGuest, setHighlightedWithGuest] = useState(new Set());
  const [highlightedNoGuest, setHighlightedNoGuest] = useState(new Set());

  useEffect(() => {
    const tmp = new Date(viewMonth.getFullYear(), viewMonth.getMonth(), 1);
    const first = firstOfWeek(tmp);
    const out = [];
    let cur = new Date(first);
    for (let r=0;r<6;r++){
      const row = [];
      for (let c=0;c<7;c++){
        row.push(new Date(cur));
        cur.setDate(cur.getDate()+1);
      }
      out.push(row);
    }
    setRows(out);
  }, [viewMonth]);

  useEffect(()=>{
    setViewMonth(startOfMonth(selected));
  },[selected]);

  useEffect(() => {
    try {
      const now = new Date();
      const withGuest = new Set();
      const noGuest = new Set();
      (appointments || []).forEach((a) => {
        try {
          const st = a.start_time ? new Date(a.start_time) : (a.start ? new Date(a.start) : null);
          if (!st || isNaN(st.getTime())) return;
          if (st.getTime() > now.getTime()) {
            const yyyy = st.getFullYear();
            const mm = String(st.getMonth() + 1).padStart(2, '0');
            const dd = String(st.getDate()).padStart(2, '0');
            const key = `${yyyy}-${mm}-${dd}`;
            (a.guest_id ? withGuest : noGuest).add(key);
          }
        } catch (e) {}
      });
      setHighlightedWithGuest(withGuest);
      setHighlightedNoGuest(noGuest);
    } catch (e) {
      setHighlightedWithGuest(new Set());
      setHighlightedNoGuest(new Set());
    }
  }, [appointments]);

  const prev = () => setViewMonth(m=> new Date(m.getFullYear(), m.getMonth()-1,1));
  const next = () => setViewMonth(m=> new Date(m.getFullYear(), m.getMonth()+1,1));

  const isSameDay = (a,b) => new Date(a).toDateString() === new Date(b).toDateString();

  return (
    <Pane width="18rem" border="muted" padding={8}>
      <Pane display="flex" alignItems="center" justifyContent="space-between" marginBottom={8}>
        <Button onClick={prev}>◀</Button>
        <strong>{viewMonth.toLocaleString('it-IT', {month:'long', year:'numeric'})}</strong>
        <Button onClick={next}>▶</Button>
      </Pane>

      <table style={{width:'100%',borderCollapse:'collapse'}}>
        <thead>
          <tr>
            <th>L</th><th>M</th><th>M</th><th>G</th><th>V</th><th>S</th><th>D</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row,i) => (
            <tr key={i}>
              {row.map((d, j) => (
                <td key={j}
                  onClick={() => setSelected(new Date(d))}
                  style={{
                    padding:6,
                    textAlign:'center',
                    cursor:'pointer',
                    background:isSameDay(d,selected)?'#e6f7ff':'transparent',
                    opacity:d.getMonth()===viewMonth.getMonth()?1:0.4
                  }}
                >
                    {(() => {
                      const yyyy = d.getFullYear();
                      const mm = String(d.getMonth() + 1).padStart(2, '0');
                      const dd = String(d.getDate()).padStart(2, '0');
                      const key = `${yyyy}-${mm}-${dd}`;
                      const todayStart = new Date(); todayStart.setHours(0,0,0,0);
                      const isPastDay = (new Date(d).setHours(0,0,0,0) < todayStart.getTime());
                      const hasGuestAppointment = highlightedWithGuest.has(key) && !isPastDay;
                      const hasNoGuestAppointment = highlightedNoGuest.has(key) && !isPastDay;
                      const isHighlighted = hasGuestAppointment || hasNoGuestAppointment;
                      return (
                        <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                          <span style={{
                            display: 'inline-block',
                            minWidth: 22,
                            lineHeight: '22px',
                            borderRadius: 12,
                            background: hasGuestAppointment ? '#fff2cc' : (hasNoGuestAppointment ? '#d9f7be' : 'transparent'),
                            fontWeight: isHighlighted ? 700 : 'normal'
                          }}>{d.getDate()}</span>
                          {hasGuestAppointment && hasNoGuestAppointment && (
                            <span style={{ display: 'flex', gap: 3, marginTop: 1 }}>
                              <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#e0b400' }} />
                              <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#389e0d' }} />
                            </span>
                          )}
                        </span>
                      );
                    })()}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </Pane>
  );
};

export default Calendar;